import { FilterOperator } from 'generated/graphql';
import { AutocompleteInput, ReferenceInput } from 'react-admin';

interface Props {
  source: string;
  disabled?: boolean;
  label?: string;
  includeUnregistered?: boolean;
}

const filterToQuery = (searchText: string) => ({
  filterCondition1: {
    fieldPath: 'email',
    operator: FilterOperator.Ilike,
    values: [`%${searchText}%`],
  },
});

export const UserInvitationInput: React.FC<Props> = ({ disabled, label, source }) => {
  return (
    <ReferenceInput reference="UserInvitation" required source={source}>
      <AutocompleteInput
        disabled={disabled}
        filterToQuery={filterToQuery}
        label={label}
        optionText="email"
        sx={{ width: '40em' }}
      />
    </ReferenceInput>
  );
};
